import request from '@/pages/iebdc/utils/request';
import { REST_SERVICE } from '@/pages/iebdc/config';

const applicantSaveService = {
  // 保存申请信息
  saveSqxx(data) {
    return request({
      url: REST_SERVICE.apply.saveSqxx,
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      data
    });
  },
  // 修改流程信息
  modifyProcessInfo(data) {
    return request({
      url: REST_SERVICE.apply.modifyProcessInfo,
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      data
    });
  },
  // 获取流程信息
  getProcessInfo(params) {
    return request({
      url: REST_SERVICE.apply.getProcessInfo,
      method: 'get',
      params
    });
  },
  //根据区域请求银行项目名称及建筑名称信息接口
  getBdcXmxx(data){
    return request({
      url: REST_SERVICE.apply.getBdcXmxx,
      method: 'post',
      // headers: {
      //   'Content-Type': 'application/json'
      // },
      data
    });
  },
  //生成缴费单
  addQlxxPay(data) {
    return request({
      url: REST_SERVICE.payment.addQlxxPay,
      method: 'post',
      data
    });
  },
  //保存缴费信息
  updateQlxxPay(data) {
    return request({
      url: REST_SERVICE.payment.updateQlxxPay,
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      data
    });
  },
  //根据不动产登记证明号获取幢信息
  getZListByBdcdjzmh(data){
    return request({
      url: REST_SERVICE.apply.getZList,
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      data
    });
  },
  //根据不动产登记证明号获取户信息
  getHListByBdcdjzmh(data){
    return request({
      url: REST_SERVICE.apply.getHList,
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      data
    });
  },
};

export default applicantSaveService;
